<template>
	<span v-if="document.price_basis">
		<span>Price basis: {{ document.price_basis == 'FOB' ? 'FOB' : 'COST' }}</span>
		<button v-if="modifiable && document.price_basis != 'FOB'" type="button" class="gray_bt mgl_15" @click="preview">
			Preview FOB conversion
		</button>
		<el-dialog title="Convert saved document to FOB" :visible.sync="visible" width="780px" append-to-body>
			<template v-if="preview_data">
				<p>Receipt history: {{ preview_data.receipt_history_state }}. Discount: {{ preview_data.discount_amount || 0 }}. Total: {{ preview_data.total_before }} → {{ preview_data.total_after }}</p>
				<p v-if="preview_data.reason">{{ preview_data.reason }}</p>
				<p v-if="!preview_data.enabled">FOB conversion is not enabled.</p>
				<p>
					Only saved FOB prices are used. Save confirmed missing prices before previewing again. Unsaved edits are not included.
				</p>
				<el-table :data="preview_data.items" max-height="360">
					<el-table-column prop="item_id" label="Item" />
					<el-table-column prop="quantity" label="Quantity" />
					<el-table-column prop="unit_price" label="Current price" />
					<el-table-column prop="fob_price" label="Saved FOB" />
					<el-table-column prop="amount_after" label="FOB amount" />
				</el-table>
				<button :disabled="busy || !preview_data.convertible" type="button" class="search_bt" @click="convert">
					Convert to FOB
				</button>
			</template>
		</el-dialog>
	</span>
</template>
<script>
import { api } from '@/api/index';
export default {
	props: ['document', 'type', 'modifiable'],
	data: () => ({ visible: false, preview_data: null, busy: false }),
	methods: {
		payload() {
			return {
				po_no: this.document.po_no,
				sh_no: this.document.sh_no,
				expected_pricing_version: this.document.pricing_version,
			};
		},
		async preview() {
			const { data } = await api.post('/api/purchasePricing/' + this.type + '/preview', this.payload());
			if (data.result === false) return this.$toast.error(data.msg);
			this.preview_data = data;
			this.visible = true;
		},
		async convert() {
			this.busy = true;
			try {
				const payload = this.payload();
				payload.expected_pricing_version = this.preview_data.expected_pricing_version;
				const { data } = await api.post('/api/purchasePricing/' + this.type + '/convert', payload);
				if (data.result === false) return this.$toast.error(data.msg);
				this.visible = false;
				this.$emit('converted');
			} finally {
				this.busy = false;
			}
		},
	},
};
</script>
